import React from 'react';
import { PillButton, Row } from 'library/ui';

const MainButtons = ({
    onWelcomeBackClick,
    onBanClick,
}: {
    onWelcomeBackClick: () => void;
    onBanClick: () => void;
}) => (
    <Row gap="md" justify="center" wrap>
        <PillButton variant="secondary" onClick={onWelcomeBackClick}>
            {`No, they're welcome back!`}
        </PillButton>
        <PillButton onClick={onBanClick}>Yes, please block</PillButton>
    </Row>
);

export default MainButtons;
